__turbopack_context__.v({
  "column": "jobListItem-module-scss-module__bdsF5W__column",
  "description": "jobListItem-module-scss-module__bdsF5W__description",
  "growingArrow": "jobListItem-module-scss-module__bdsF5W__growingArrow",
  "icon": "jobListItem-module-scss-module__bdsF5W__icon",
  "jobListItem": "jobListItem-module-scss-module__bdsF5W__jobListItem",
  "noDescription": "jobListItem-module-scss-module__bdsF5W__noDescription",
  "row": "jobListItem-module-scss-module__bdsF5W__row",
  "subtitle": "jobListItem-module-scss-module__bdsF5W__subtitle",
  "title": "jobListItem-module-scss-module__bdsF5W__title",
});
